<div class="container-fluid mb-3">
    <div class="bg-light mb-4 rounded-2 py-5 px-3">
        <h1>Oops!</h1>
        <p class="lead">Nothing here! <con-icon-by-name iconName="frown-o"></con-icon-by-name></p>
    </div>
</div>
